import {Component, Input, output} from '@angular/core';
import { TableComponent } from '../../../utils/table/table.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AResourceTableComponent } from '../../../AResourceTableComponent';
import { LocationModel } from '../../../../models/resources/location.model';
import { FormGroupHelper } from '../../../../helpers/form-group-helper';
import { TableColumnModel } from '../../../../models/table-column.model';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { CustomNotificationService } from '../../../../services/utils/custom-notification.service';
import {LocationService} from "../../../../services/resources/location.service";
import {finalize} from "rxjs";

@Component({
  standalone: true,
  selector: 'app-meeting-points-table',
  imports: [
    TableComponent,
    ReactiveFormsModule
  ],
  template: `<app-table
    [columns]="tableColumns"
    [data]="models()"
    [filterFormGroup]="filterFormGroup"
    [loading]="resourceService.loading()"
    (doFilterRequest)="loadLocations($event)"
    (urlParamsChange)="this.urlParams = $event"
    [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
    [pagination]="resourceService.paginationMeta()"
    [deleteLoadingIds]="this.deleteLoadingIds()"
  />`,
  styles: ``
})
export class MeetingPointsTableComponent extends AResourceTableComponent<LocationModel>{
  @Input() meetingPoint?: LocationModel;
  deletedMeetingPoint = output<number>()

  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [ 'address' ]);

  tableColumns: TableColumnModel[] = [
    {
      name: 'LOCATIONS.IS_ACTIVE',
      selector: [{ selector: 'active' }],
      isCheckbox: true
    },
    {
    name: 'MEETING_POINTS.ADDRESS',
    selector: [
      {
        selector: 'address.postcode',
        suffix:' '
      },
      {
        selector: 'address.place',
        suffix: ', '
      },
      {
        selector: 'address.country',
        suffix:'. '
      },
      {
        selector: 'address.street',
        suffix: ' '
      },
      {
        selector: 'address.houseNumber',
        suffix: ' '
      },
      { selector: 'address.addressSuffix' }
    ],
    filterFormControl: this.filterFormGroup.get('address'),
    filterFormControlLabel: 'MEETING_POINTS.ADDRESS',
    filterUrlParam: 'address'
  },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          isObjectLink: true,
          objectBaseLink: '/meeting-points'
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ]

  constructor(
    formBuilder: FormBuilder,
    public locationService: LocationService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      locationService,
      httpErrorsService,
      notificationService,
      'MEETING_POINTS');
  }
  override ngOnInit(): void {
    this.loadLocations();

  }
  loadLocations(params: any = {}): void {

    this.locationService.getAll({
      ...params,
      urlParams: [
        ...(params.urlParams ?? []),

        {
          key: 'type',
          value: 'meeting_point'
        },
      ],
    });
  }
  override delete(id: number){
    this.deleteLoadingIds.update((ids) => {
      return [...ids, +id];
    });

    this.locationService
      .delete(id)
      .pipe(
        finalize(() => {
          this.deleteLoadingIds.update((ids) => {
            return ids.filter((i) => i != id);
          });
        }),
      )
      .subscribe({
        next: () => {
          this.loadLocations({
            urlParams: this.urlParams,
            lazyLoad: true,
          })
          this.notificationService.success('LOCATIONS.SUCCESSFULLY_DELETED');
          this.deletedMeetingPoint.emit(id);
        },
        error: (e) => {
          this.httpErrorsService.handleError(e);
        }
      })
  }
}
